module.exports = __webpack_public_path__ + "assets/730e6f3b70b4dc60d6f6fba937fbb19e.woff2";